import ErrorIcon from "@mui/icons-material/Error";
import { Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ErrorTypography } from "components/ErrorTypography";
import { useWriterComponentState } from "hooks";

import { EVOTRUX_GREEN } from "../../../../../constants";

interface Props {
  userUUID: string | null;
  verifyError: UIError;
}

export function VerifyFailure(props: Props) {
  const { userUUID, verifyError } = props;

  const navigate = useNavigate();

  const {
    loading,
    error: resendError,
    success,
    write: resendEmail,
  } = useWriterComponentState({
    writeConfig: {
      method: "post",
      url: "/verify/resend",
      body: {
        user_uuid: userUUID,
      },
    },
    unauthenticatedRequest: true,
    errorMessage: "Failed to resend code. Please contact us.",
  });

  return (
    <Container maxWidth="lg">
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <ErrorIcon color="error" />
          <Typography variant="h5">
            There was an error verifying your account
          </Typography>
        </Stack>
        {!success && <ErrorTypography error={resendError ?? verifyError} />}
        <Button
          disabled={loading}
          variant="contained"
          onClick={() => resendEmail()}
        >
          Resend Verification Email
        </Button>
        <Button variant="contained" onClick={() => navigate("/login")}>
          Return to login
        </Button>
        {success && (
          <Typography sx={{ color: EVOTRUX_GREEN }} align="center">
            A new verification code has been sent to your email.
          </Typography>
        )}
      </Stack>
    </Container>
  );
}
